import _ from 'lodash';
import React from 'react';

import useUI from 'hooks/use-ui';

import { GqlMenuSection } from 'types/graphql';
import MenuImage from 'src/components/menu-image-banner/menu-image';
import { getEnabledBanners } from 'src/components/menu-image-banner/menu-image-banner';
import { Section } from '../carousels.styles';

const ImageSection = ({ section }: { section: GqlMenuSection }): JSX.Element | null => {
  const { isKiosk } = useUI();

  if (!section.image) {
    return null;
  }

  const enabledBanners = getEnabledBanners([section.image], isKiosk);
  if (!enabledBanners.length) {
    return null;
  }

  return (
    <Section noBorder data-testid='image-section'>
      <MenuImage banner={enabledBanners[0]} fixedSize={false} index={0} />
    </Section>
  );
};

export default ImageSection;
